exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found {\n  margin: 1em auto;\n  width: 1000px;\n  background: white;\n  clear: both;\n  padding: 2em 0; }\n  .not-found .status {\n    font-size: 7em;\n    font-weight: bold;\n    color: #e0e0e0;\n    text-align: center; }\n  .not-found .heading {\n    text-align: center;\n    color: #aaaaaa; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/NotFoundComponent/notFound.component.scss
// module id = ./src/app/common/components/NotFoundComponent/notFound.component.scss
// module chunks = main